import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { IconChevronUp } from '@prisjakt/ui/icon/chevron-up';
import { IconChevronDown } from '@prisjakt/ui/icon/chevron-down';

const listSidePadding = '0.6rem';

/* stylelint-disable property-no-vendor-prefix */
export const HiddenInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: 0;
  opacity: 0;
  position: absolute;
`;
/* stylelint-enable property-no-vendor-prefix */

const listSideHeight = 2.6; // rem

export const RadioButton = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-left: 2px;
  margin-top: 2px;
  margin-right: 10px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: ${props => props.theme.colors.base0};
  border: 1px solid ${props => props.theme.colors.base300};
  ${props =>
    props.checked &&
    css`
      background-color: ${props.theme.colors.base0};
      box-shadow: 0 0 0 1px ${props.theme.colors.base300};
      border: 5px solid ${props.theme.colors.maybeBlue700};
      color: ${props.theme.colors.base700};
    `}
`;

export const Label = styled.label`
  height: 2.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding-right: ${ifProp({ layout: 'horizontal' }, 20, 0)}px;
  color: ${props => props.theme.colors.base600};
  &:hover {
    background-color: ${props => props.theme.colors.base100};
  }

  ${props =>
    props.selected &&
    css`
      font-weight: 600;
    `}
`;

export const Counter = styled.span`
  margin-left: 5px;
  margin-right: 5px;
  color: ${props => props.theme.colors.base500};
`;

export const Layout = styled.div`
  display: ${ifProp({ layout: 'horizontal' }, 'flex', 'block')};
  flex-wrap: wrap;
`;

export const ListItem = styled.div`
  display: block;
  user-select: none;
  position: relative;
  padding-left: ${listSidePadding};
  font-weight: ${ifProp('selected', '600', 'normal')};
  &:hover {
    background-color: ${props => props.theme.colors.base100};
  }
`;

export const ListLabel = styled.label`
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

export const Checkbox = styled.div`
  margin-right: ${listSidePadding};
  display: flex;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.base300};

  ${props =>
    (props.checked || props.partial) &&
    css`
      background-color: ${props.theme.colors.maybeBlue700};
      border: 1px solid ${props.theme.colors.maybeBlue700};
    `}
`;

export const ListLabelText = styled.span`
  display: flex;
  flex-grow: 1;
  color: ${props => props.theme.colors.base600};
`;

export const ListLabelName = styled.span`
  word-break: break-word;
  word-wrap: break-word;
`;

export const ListLabelByline = styled.span`
  align-self: center;
  color: ${props => props.theme.colors.base500};
  margin-left: 5px;
  margin-right: 5px;
`;

export const ExpandWrapper = styled.span`
  margin-left: auto;
`;

export const ExpandButton = styled.button`
  display: inline-block;
  cursor: pointer;
  width: ${listSideHeight}rem;
  height: ${listSideHeight / 2}rem;
  padding: 0;
  text-align: center;

  ${props =>
    props.expanded &&
    css`
      background-color: rgba(${props.theme.colors.base200}, 0.4);
      &:hover,
      &:active,
      &:focus {
        background-color: rgba(${props.theme.colors.base200}, 0.4);
      }
    `}
`;

export const ArrowUp = styled(IconChevronUp).attrs({
  color: 'base300',
})``;

export const ArrowDown = styled(IconChevronDown).attrs({
  color: 'base300',
})``;
